import { render, staticRenderFns } from "./WorkHours.vue?vue&type=template&id=2dfcb392&scoped=true&"
import script from "./WorkHours.vue?vue&type=script&lang=js&"
export * from "./WorkHours.vue?vue&type=script&lang=js&"
import style0 from "./WorkHours.vue?vue&type=style&index=0&id=2dfcb392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfcb392",
  null
  
)

export default component.exports